"use client";

import type { Variety } from "@/lib/catalog/types";

export function GradePicker({
  variants,
  activeSlug,
  onChange,
}: {
  variants: Variety[];
  activeSlug: string;
  onChange: (variant: Variety) => void;
}) {
  if (variants.length <= 1) return null;
  return (
    <div data-testid="detail-grade-picker" className="flex flex-wrap gap-2">
      {variants.map((v) => {
        const isActive = v.slug === activeSlug;
        return (
          <button
            key={v.slug}
            type="button"
            data-testid={`detail-grade-${v.grade?.toLowerCase()}`}
            data-grade={v.grade}
            aria-pressed={isActive}
            onClick={() => onChange(v)}
            className={
              isActive
                ? "rounded-full bg-brand-teal px-4 py-1.5 text-sm font-semibold text-white"
                : "rounded-full border border-brand-border bg-white px-4 py-1.5 text-sm font-medium text-brand-text-muted hover:border-brand-teal hover:text-brand-text"
            }
          >
            {v.grade}
          </button>
        );
      })}
    </div>
  );
}
